// in src/Menu.js
import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'admin-on-rest';
import { getResources } from 'admin-on-rest/lib/reducer';
import { compose } from 'recompose';
import inflection from 'inflection';
import { get } from 'lodash';
import TranslationIcon from 'material-ui/svg-icons/content/font-download';
import OrganisationIcon from 'material-ui/svg-icons/social/location-city';
import FAQIcon from 'material-ui/svg-icons/action/question-answer';
import ProfileIcon from 'material-ui/svg-icons/social/person';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import { ListItem } from 'material-ui';
import LocalParkingIcon from 'material-ui/svg-icons/maps/local-parking';
import NewsIcon from 'material-ui/svg-icons/av/web';
// import HelpIcon from 'material-ui/svg-icons/action/help';
import BookingIcon from 'material-ui/svg-icons/action/event';
import RefundIcon from 'material-ui/svg-icons/editor/attach-money';
import MarketingMaterialIcon from 'material-ui/svg-icons/file/folder-open';
import WorkIcon from 'material-ui/svg-icons/action/work';
import ChartIcon from 'material-ui/svg-icons/editor/insert-chart';
import LinkIcon from 'material-ui/svg-icons/content/link';
import CogwheelIcon from 'material-ui/svg-icons/action/settings';
import StarsIcon from 'material-ui/svg-icons/action/stars';
import MoneyIcon from 'material-ui/svg-icons/maps/local-atm';

import LocaleSwitcher from './LocaleSwitcher';
import MenuListItemLink from './MenuListItemLink';
import VenueSwitcher from './VenueSwitcher';
import { hasPositions, isSuperUser } from '../utils/permissionsUtils';

const translatedResourceName = (resource, t) => t(`resources.${resource.name}.name`, {
  smart_count: 2,
  _:
      resource.options && resource.options.label
        ? t(resource.options.label, {
          smart_count: 2,
          _: resource.options.label,
        })
        : inflection.humanize(inflection.pluralize(resource.name)),
});

class Menu extends React.Component {
  render() {
    const {
      user,
      permissions,
      resources,
      onMenuTap,
      logout,
      // eslint-disable-next-line no-shadow
      translate,
    } = this.props;

    let mainResources = resources.filter((resource) => !resource.parent);
    const childResources = resources.filter((resource) => resource.parent);
    mainResources = mainResources.map((resource) => {
      let childMenuItems = childResources.filter(
        (childResource) => childResource.parent === resource.name && !childResource.hidden
      );
      // eslint-disable-next-line
      childMenuItems = childMenuItems.map((resource) => {
        // eslint-disable-next-line
        const childMenuItems = childResources.filter(
          (childResource) => childResource.parent === resource.name && !childResource.hidden
        );
        return { ...resource, childMenuItems };
      });
      return { ...resource, childMenuItems };
    });
    // console.log(permissions)
    // const permissions = JSON.parse(localStorage.getItem('permissions'));

    // const encodedUser = encodeURI(btoa(JSON.stringify(user)));

    return (
      <div id="sidebar" style={{ paddingBottom: '3em' }}>
        <VenueSwitcher user={user} />
        <MenuListItemLink
          key="news"
          to="/"
          primaryText={translate('news.news')}
          leftIcon={<NewsIcon />}
          onClick={onMenuTap}
          permissions={permissions}
        />

        {user
          && (isSuperUser(user)
            || hasPositions(user, [
              'restaurantManager',
              'franchisees',
              'barManager',
              'chef',
              'steward',
            ])
          ) && (
          <MenuListItemLink
            key="statistics"
            // to="/statistics"
            href="https://restaurant.pinchos.se/dashboards"
            primaryText={translate('statistics.title')}
            leftIcon={<ChartIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}

        {user && (
          <MenuListItemLink
            key="dashboard"
            // href={`https://dashboards.pinchos.se?${encodedUser}`}
            href="https://restaurant.pinchos.se/dashboards"
            primaryText="Ratings"
            leftIcon={<StarsIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}


        {user && (
          <MenuListItemLink
            key="bireports"
            // href={`https://dashboards.pinchos.se/xsale?${encodedUser}`}
            href="https://restaurant.pinchos.se/dashboards"
            primaryText={translate('bireports')}
            leftIcon={<MoneyIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}

        <ListItem
          primaryText={translate('externalLinks')}
          leftIcon={<LinkIcon />}
          primaryTogglesNestedList
          nestedItems={[
            <MenuListItemLink
              key="reimbursement"
              href="https://restaurant.pinchos.se/history"
              target="_blank"
              primaryText={translate('reimbursement')}
              leftIcon={<RefundIcon />}
              onClick={onMenuTap}
              permissions={permissions}
            />,
            <MenuListItemLink
              key="booking"
              href="https://admin-booking.pinchos.se"
              target="_blank"
              primaryText={translate('booking')}
              leftIcon={<BookingIcon />}
              onClick={onMenuTap}
              permissions={permissions}
            />,
            <MenuListItemLink
              key="marketing-material"
              href="https://drive.google.com/drive/folders/1zgnBo6xQz0bWJdjALUArOJXKy-vIwWw2?usp=sharing"
              target="_blank"
              primaryText={translate('marketing-material')}
              leftIcon={<MarketingMaterialIcon />}
              onClick={onMenuTap}
              permissions={permissions}
            />,
            <MenuListItemLink
              key="marketingPortal"
              href="https://live.flexprint.se/espressi/Login.aspx"
              primaryText={translate('marketingPortal')}
              leftIcon={<MarketingMaterialIcon />}
              onClick={onMenuTap}
              permissions={permissions}
              visible={user && (isSuperUser(user)
                || hasPositions(user, [
                  'restaurantManager',
                  'franchisees',
                  'socialMediaManager',
                ]))}
            />,
          ]}
        />

        {user && (
          user.superUser || hasPositions(user, ['franchisees', 'restaurantManager'])) && (
          <MenuListItemLink
            key="booking-settings"
            href="https://admin-booking.pinchos.se/settings"
            primaryText={translate('booking-settings')}
            leftIcon={<CogwheelIcon />}
            onClick={onMenuTap}
          />
        )}

        {user && (
          <MenuListItemLink
            key="profile"
            to={`/profile/${user.phoneNumber}`}
            primaryText="My profile"
            leftIcon={<ProfileIcon />}
            onClick={onMenuTap}
          />
        )}

        <MenuListItemLink
          key="pinchoversity"
          href="https://pinchonation.learnifier.com/login/lapi/sso/c334cb28-290c-497e-a226-573711913acb/login"
          primaryText="Pinchoversity"
          leftIcon={<SchoolIcon />}
          onClick={onMenuTap}
          permissions={permissions}
        />

        <MenuListItemLink
          key="teamtailor"
          to="/team-tailor"
          primaryText={translate('jobs')}
          leftIcon={<WorkIcon />}
          onClick={onMenuTap}
          permissions={permissions}
        />

        <MenuListItemLink
          key="pn-contact"
          to="/pn-contact"
          primaryText={translate('pn-contact')}
          leftIcon={<OrganisationIcon />}
          onClick={onMenuTap}
          permissions={permissions}
        />
        {permissions && permissions.organisationManager && (
          <MenuListItemLink
            key="organisation"
            to="/organisation"
            primaryText="Organisation"
            leftIcon={<OrganisationIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}

        {user && user.superUser && (
          <MenuListItemLink
            key="faq"
            to="/faq-viewer"
            primaryText="FAQ"
            leftIcon={<FAQIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}


        {user && user.superUser ? (
          <MenuListItemLink
            key="pinchos"
            to="/pinchos"
            primaryText="Pinchos"
            leftIcon={<LocalParkingIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        ) : null}

        {permissions && permissions.translator && (
          <MenuListItemLink
            key="translations"
            to="/translations"
            primaryText="Translations"
            leftIcon={<TranslationIcon />}
            onClick={onMenuTap}
            permissions={permissions}
          />
        )}

        {
          // user && isSuperUser(user) &&
          // <MenuListItemLink
          //   key="ratings"
          //   to="/ratings"
          //   primaryText="Ratings"
          //   leftIcon={<StarsIcon />}
          //   onClick={onMenuTap}
          //   permissions={permissions}
          // />
        }

        {permissions
          && mainResources
            .filter(
              (r) => permissions.resources[r.name]
                && permissions.resources[r.name].list
            )
            .map((resource) => {
              let nestedItems = [];

              if (resource.childMenuItems.length > 0) {
                const nestedChildren = resource.childMenuItems.map(
                  (childResource) => {
                    let grandKids = [];

                    // check for doubly nested menuItems (grandChildren)
                    if (childResource.childMenuItems) {
                      grandKids = childResource.childMenuItems.map(
                        (grandChild) => (
                          <MenuListItemLink
                            key={grandChild.name}
                            to={`/${grandChild.name}`}
                            primaryText={translatedResourceName(
                              grandChild,
                              translate
                            )}
                            leftIcon={<grandChild.icon />}
                            onClick={onMenuTap}
                          />
                        )
                      );
                    }
                    return (
                      <MenuListItemLink
                        key={childResource.name}
                        to={`/${childResource.name}`}
                        primaryText={translatedResourceName(
                          childResource,
                          translate
                        )}
                        leftIcon={<childResource.icon />}
                        onClick={onMenuTap}
                        nestedItems={grandKids.length > 0 && grandKids}
                      />
                    );
                  }
                );

                const FirstMenuChild = resource.hideFirstChild
                  ? []
                  : [
                    <MenuListItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={translatedResourceName(
                        resource,
                        translate
                      )}
                      leftIcon={<resource.icon />}
                      onClick={onMenuTap}
                      insetChildren
                    />,
                  ];

                nestedItems = [...FirstMenuChild, ...nestedChildren];
              }

              return resource.hidden ? null : resource.childMenuItems.length > 0 ? (
                <ListItem
                  key={resource.name}
                  primaryText={translate(
                    `menuTitles.${resource.menuTitle || resource.name}`
                  )}
                  leftIcon={<resource.icon />}
                  primaryTogglesNestedList
                  insetChildren
                  nestedItems={
                    resource.childMenuItems.length > 0 && nestedItems
                  }
                />
              ) : (
                <MenuListItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={translatedResourceName(resource, translate)}
                  leftIcon={<resource.icon />}
                  onClick={onMenuTap}
                />
              );
            })}

        <LocaleSwitcher />
        {logout}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  resources: getResources(state),
  user: get(state, 'auth.user'),
  permissions: get(state, 'auth.permissions'),
});

const enhance = compose(
  translate,
  connect(mapStateToProps)
);

export default enhance(Menu);
